import { reduxKey } from './constants';
export const getFirstTimeFlags = (state)=>{
    return state[reduxKey] || {};
};
export const hasFirstTimeFlag = (state, flag)=>{
    return Boolean(getFirstTimeFlags(state)[flag]);
};
